const SwitchToggle = ({ value, onChange, label }) => {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
      <label
        style={{
          position: "relative",
          display: "inline-block",
          width: 40,
          height: 20,
        }}
      >
        <input
          type="checkbox"
          checked={value}
          onChange={(e) => onChange(e.target.checked)}
          style={{ display: "none" }}
        />
        <span
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: value ? "#35C657" : "#C0C7D6",
            borderRadius: 20,
            transition: "0.3s",
          }}
        />
        <span
          style={{
            position: "absolute",
            height: 16,
            width: 16,
            left: value ? 20 : 2,
            bottom: 2,
            backgroundColor: "white",
            borderRadius: "50%",
            transition: "0.3s",
          }}
        />
      </label>
      {label && (
        <span style={{ fontSize: 12, fontWeight: 500, color: "#767A80" }}>
          {label}
        </span>
      )}
    </div>
  );
};

export default SwitchToggle;
